import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import {
  CreateNewWorkspaceModalAction,
  CreateNewWorkspaceModalResponse,
} from './create-new-workspace-modal.service'

@Component({
  selector: 'hs-create-new-workspace-modal',
  templateUrl: './create-new-workspace-modal.component.html',
})
export class CreateNewWorkspaceModalComponent implements OnInit {
  name = ''
  description = ''
  isSubmitEnabled = false

  constructor(readonly activeModal: NgbActiveModal) {}

  ngOnInit() {
    this.updateIsSubmitEnabled()
  }

  onSave() {
    this.close(CreateNewWorkspaceModalAction.SAVE)
  }
  onSaveAndActivate() {
    this.close(CreateNewWorkspaceModalAction.SAVE_AND_ACTIVATE)
  }

  updateIsSubmitEnabled() {
    this.isSubmitEnabled =
      this.name != null &&
      this.name != '' &&
      this.description != null &&
      this.description != ''
  }

  private close(action: CreateNewWorkspaceModalAction) {
    if (!this.isSubmitEnabled) return

    const response: CreateNewWorkspaceModalResponse = {
      name: this.name,
      description: this.description,
      action,
    }
    this.activeModal.close(response)
  }
}
